import moment from 'moment'
import type { BusinessDataType } from '../context/BusinessContext'
import type { FiltersType } from '../context/CommonContext'
import { matchesTokens, tokenize } from './searchUtils'
import { businessHaystack, type BusinessSearchIndex } from './businessSearchIndex'

const businessFilter = (businessData: BusinessDataType, filters: FiltersType, searchIndex?: BusinessSearchIndex) => {
    const searchTokens = tokenize(filters.search)
    const today = moment().format('YYYY-MM-DD')
    const startOfWeek = moment().startOf('week')
    const startOfNextWeek = moment().startOf('week').add(7, 'days')

    return {
        ...businessData,
        pipelines: businessData.pipelines
            .map(pipeline => ({
                ...pipeline,
                steps: pipeline.steps
                    .map(step => ({
                        ...step,
                        business: step.business.filter(business => {
                            //? Filtro search (tokens em qualquer ordem, sem acentos/caixa, sobre todos os dados do negócio)
                            const matchesSearch =
                                searchTokens.length === 0 ||
                                matchesTokens(
                                    searchIndex?.get(String(business.id)) ?? businessHaystack(business),
                                    searchTokens
                                )

                            //? Filtro por tempo
                            let matchesTime = true
                            if (filters.time && business.dateNotify) {
                                const date = moment(business.dateNotify, 'YYYY-MM-DD')
                                switch (filters.time) {
                                    case 'today':
                                        matchesTime = date.isSame(today, 'day')
                                        break
                                    case 'thisWeek':
                                        matchesTime = date.isBetween(startOfWeek, moment().endOf('week'), 'day', '[]')
                                        break
                                    case 'nextWeek':
                                        matchesTime = date.isBetween(
                                            startOfNextWeek,
                                            startOfNextWeek.clone().endOf('week'),
                                            'day',
                                            '[]'
                                        )
                                        break
                                    case 'expired':
                                        matchesTime = date.isBefore(moment(), 'day')
                                        break
                                }
                            } else if (filters.time && !business.dateNotify) {
                                matchesTime = false
                            }

                            //? Filtro por profissional
                            const matchesProfessionals =
                                filters.creators.length > 0
                                    ? filters.creators.some(f => Number(f.id) === Number(business.professionalID))
                                    : true

                            //? Filtro products
                            const matchesProducts =
                                filters.products.length > 0
                                    ? !!business.products?.some(product =>
                                          filters.products.some(f => Number(f.id) === Number(product.id))
                                      )
                                    : true

                            //? Filtro targets
                            const matchesTargets =
                                filters.targets.length > 0
                                    ? business.targets?.some(target =>
                                          filters.targets.some(
                                              f =>
                                                  f.id === target.id ||
                                                  f.label.toLowerCase() === target.label.toLowerCase()
                                          )
                                      )
                                    : true

                            //? Filtro companies
                            const matchesCompanies =
                                filters.companies.length > 0
                                    ? filters.companies.some(f => Number(f.id) === Number(business.company?.id))
                                    : true

                            return (
                                matchesSearch &&
                                matchesTime &&
                                matchesProfessionals &&
                                matchesProducts &&
                                matchesTargets &&
                                matchesCompanies
                            )
                        })
                    }))
                    .filter(step => step.business.length > 0) // Remove steps sem negocios apos filtro
            }))
            .filter(pipeline => pipeline.steps.length > 0) // Remove pipelines sem steps apos filtro
    }
}

export { businessFilter }
